import React, { useContext } from 'react';
import background from '../../assets/image/tinyBackground.png';
import { useInformationData } from '../../hooks/useInformationData';
import { LoginForm } from './LoginForm/loginform';
import { LoginPlantInfo } from './LoginPlantInfo/loginPlantInfo';
import { TextContext } from '../../context/TextCotext';

export default function Login() {
  const { information, loading } = useInformationData();

  return (
    <div className="flex items-center h-screen bg-white">
      <div className="bg-white flex flex-col gap-4 items-center md:items-start flex-1 mx-auto max-w-[270px]">
        <LoginForm InfoData={information} />
      </div>
      <div
        className="hidden md:block w-1/2 flex flex-col h-screen"
        style={{ backgroundImage: `url(${background})` }}
      >
        <LoginPlantInfo InfoData={information}  />
      </div>
    </div>
  );
}
